var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-row',{staticClass:"my-3 w-100",attrs:{"no-gutters":""}},[_vm._v(" BENE AZIENDA TODO ")])
}
var staticRenderFns = []

export { render, staticRenderFns }